import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import { black, ButtonBrand, gold, TypographyBrand } from '../../../getLPTheme';
import Container from '@mui/material/Container';
import { Collapse, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { jwtDecode } from 'jwt-decode'; 
import { options } from '@config';
import Loading from '../../../auxiliares/loading';

export interface JwtPayload {
  role: string;
}

export default function Login() {
  const paperStyle = { height: '70vh', width: 300 };
  const btnstyle = { margin: '8px 0' };
  const [openProgress, setopenProgress] = React.useState(false);
  const [closeResetPassword, setcloseResetPassword] = React.useState(true);
  const [showResetButton, setShowResetButton] = React.useState(false);
  const [openOptions, setopenOptions] = React.useState(true);
  const [showPassword, setShowPassword] = React.useState(false);
  const [user, setUser] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [openMessage, setopenMessage] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const navigate = useNavigate();
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => { event.preventDefault(); };

  const handleForgotPassword = async () => {

    setopenOptions(false)
    setopenProgress(true)

    try {
      const response = await fetch((options.api.url + "forgotpass"), {
        method: 'POST',
        mode: "cors",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user }),
      });

      if (!response.ok) {
        setopenProgress(false)
        setError('El usuario no existe, intente nuevamente');
        return;
      }

      setMessage('Se ha enviado un mail a su correo con un link para reestablecer contraseña')
      setopenProgress(false)
      setopenOptions(false)
      setopenMessage(true)

    } catch (error) {
      setopenProgress(false)
      setError('Error al restablecer contraseña. Por favor, intente nuevamente.');
    }
  };


  const handleLogin = async () => {
    setopenOptions(false)
    setopenProgress(true)
    try {
      console.log("options: ", options)
      const response = await fetch((options.api.url + "login"), {
        method: 'POST',
        mode: "cors",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user, password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setopenProgress(false)
        setopenOptions(true)
        setError(errorData.error);
        return;
      }

      interface JwtPayload {
        role: string;
      }

      const result = await response.json();
      const token = result.token
      const decodedToken = jwtDecode(token);

      localStorage.setItem('CLUB-VIP-JWT', token);
      localStorage.setItem('CLUB-VIP-AVATAR', decodedToken?.avatar);
      localStorage.setItem('CLUB-VIP-USER', decodedToken?.user);

      if(decodedToken?.role == "admin"){
        navigate('/admin');
      }else{
        navigate('/user');
      }
    } catch (error) {
      setopenProgress(false)
      setError('Error al iniciar sesión. Por favor, intenta nuevamente.');
    }
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: { xs: 10, sm: 12 },
        pb: { xs: 4, sm: 6 },
      }}
    >
      <Box
        sx={{
          borderRadius: 1,
          bgcolor: black[900],
          display: 'grid',
          gridTemplateColumns: { md: '1fr 1fr' },
          width: 300,
          height: 'auto',
          direction: "column",
          justifyContent: "center",
          alignItems: "center",
          border: 1,
          borderColor: gold[500]
        }}
      >
        <Grid>
          <Paper elevation={24} style={paperStyle}>
            <Box sx={{ padding: 1 }}>
              <Grid container direction="column" justifyContent="center" alignItems="center">
                <Box sx={{pt: 2}}><Avatar sx={{ bgcolor: gold[400], width: 70, height: 70 }}></Avatar></Box>
              </Grid>
              <h2>Iniciar Sesion</h2>
              <TextField
                InputLabelProps={{ shrink: false }}
                margin="dense"
                size="small"
                label=''
                placeholder='Ingresa tu mail'
                type='email'
                required
                value={user}
                onChange={(e) => setUser(e.target.value)}
                sx={{ }}
              />
              <Collapse in={closeResetPassword}>
                <TextField
                  InputLabelProps={{ shrink: false }}
                  margin="dense"
                  size="small"
                  label=''
                  placeholder='Ingresa tu contraseña'
                  required
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Collapse>
              {error && <Typography color="#e89b9b">{error}</Typography>}
              <Collapse in={closeResetPassword}>
                <ButtonBrand
                  type='submit'
                  fullWidth
                  onClick={handleLogin}
                  sx={{mt:2, mb:2}}
                >
                  Iniciar Sesion
                </ButtonBrand>
              </Collapse>
              <Collapse in={showResetButton}>
                <ButtonBrand
                  type='submit'
                  fullWidth
                  onClick={handleForgotPassword}
                  sx={{mt:2, mb:2}}
                >
                  Restablecer contraseña
                </ButtonBrand>
              </Collapse>
              <Collapse in={openProgress}>
                  <Box sx={{width:"100%", display: "flex", justifyContent:"center", alignItems:"center"}}>
                      <Loading/>
                  </Box>
              </Collapse>
              <Collapse in={openMessage}>
                <Box sx={{width:"100%", display: "flex", justifyContent:"center", alignItems:"center"}}>
                  <Typography color="#e89b9b">{message}</Typography>
                </Box>
              </Collapse>
              <Collapse in={openOptions}>
                <Typography>
                  <RouterLink to={"#"} style={{ textDecoration: 'none' }}>
                    <Link onClick={ () => (setShowResetButton(true), setcloseResetPassword(false))}>
                      Olvidaste tu contraseña?
                    </Link>
                  </RouterLink>
                </Typography>
                <Typography>
                  Aun no tenes una cuenta?
                  <RouterLink to={"/registrarse"} style={{ textDecoration: 'none' }}>
                    <Link padding={1}>
                      Registrarse
                    </Link>
                  </RouterLink>
                </Typography>
              </Collapse>
            </Box>
          </Paper>
        </Grid>
      </Box>
    </Container>
  );
}